import { motion } from 'motion/react'
import { Button } from '@/components/shadcn/button'
import { IconFilterOutline, IconPinboardOutline } from '@/components/icons'

interface HeaderActionsProps {
  isConfiguringLayout: boolean
  toggleIsConfiguringLayout: () => void
  toggleShowFilters: () => void
}

export function HeaderActions({
  isConfiguringLayout,
  toggleIsConfiguringLayout,
  toggleShowFilters,
}: HeaderActionsProps) {
  return (
    <motion.div layout className="flex gap-x-1">
      <Button
        variant={isConfiguringLayout ? 'default' : 'ghost'}
        className=""
        size="icon"
        onClick={toggleIsConfiguringLayout}
      >
        <IconPinboardOutline className="size-5" />
      </Button>
      <Button variant="ghost" className="" size="icon" onClick={toggleShowFilters}>
        <IconFilterOutline className="size-5" />
      </Button>
    </motion.div>
  )
}
